export const API_BASE_URL = 'https://ema.ba';